import { IonContent, IonInput, IonPage, IonText,IonSpinner } from "@ionic/react"
import { useEffect, useState ,useMemo} from "react";
import { useHistory } from "react-router";
import DataTable from "react-data-table-component";
import Head from "../../Header";
import Sidebar from "../../Sidebar";
import moment from "moment";
import { Modal } from "react-bootstrap";
import service from "../../../Service/service";
import swal from 'sweetalert';

const HREmployementtype: React.FC = () => {
    const history = useHistory();
    const [token] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {
        if (token === null) {
          history.push("/login");
        } else {
        }
      }, [token, history]);

    const [data, setData] = useState([]);

    data.forEach((item: any, index: any) => { item.serial = index + 1; });

    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [modalopen, setModalopen] = useState(false);
    const [modalopen1, setModalopen1] = useState(false);
    const [loading,setloading]=useState(false)

    /*.............. View .........*/
    const [ETypeName, setETypeName] = useState("");
    const [ETypeDescription, setETypeDescription] = useState("");
    const [Resources, setResources] = useState([]);

    /*.............. Update ........ */
    const [Id, setId] = useState("");
    const [crtby] = useState(localStorage.getItem('SignupEmpId'));
    const [updtby] = useState(localStorage.getItem('SignupEmpId'));

    /*.............. Create ......... */
    const [eTName, setETName] = useState("");
    const [eTDescription, setETDescription] = useState("");

    /*.............Employement typelist Api...............*/

    useEffect(() => {
        LoadEmploymentType()
    }, []);

    const LoadEmploymentType = () => {
        setloading(true);
        service.getEmployementTypeList()
            .then((response) => {
                console.log(response, "data");
                if (response.data.Status === "200") {
                    setData(response.data.Data);
                } else {
                    setData([]);
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                
                setTimeout(() => {
                    setloading(false); 
                }, 500); 
            });
    };

 /*..................Modal View Api..................*/

    const openmodal = (id: any) => {
        setModalopen(true);
        setId(id);
        service.GetEmployeTypeViewId(id)
            .then((response) => {
                if (response.status == 200) {
                    console.log(response.data);
                    setETypeName(response.data.Data.employmentTypesName);
                    setETypeDescription(response.data.Data.employmentTypesDescription);
                    setResources(response.data.Resources)
                    console.log(response.data)
                }
            })
    }

    const openmodal1 = () => {
        setModalopen1(true);
    }

    const closemodal = () => {
        setModalopen(false);
    }
    const back = () => {
        history.goBack();
    }
/*...................Create Designation..................*/

    const Create = () => {
        if (eTName.length === 0) {
            swal("","Please Enter Employeement Type Name ","error")
        }
        else {
            service.CreateEmployeeType(eTName, eTDescription, crtby, updtby)
                .then((response) => {
                    console.log(response.status);
                    if (response.data.status === "200") {
                        console.log(response.data);
                        setETName("");
                        setETDescription("");
                        swal("", "Created Successfully", "success");
                        window.location.reload();
                    }
                    else {
                        swal("", response.data.message, "info");
                    }
                })
        }

    }

/*.....................Update Designation......................*/

    const Update = () => {
        if (ETypeName.length === 0) {
            swal("","Please Enter Employeement Type Name ","error")
        }
        else {
            service.UpdateEmployeeType(ETypeName, ETypeDescription, crtby, updtby, Id)
                .then((response) => {
                    console.log(response.status);
                    if (response.status == 200) {
                        console.log(response.data);
                        swal("", "Updated Successfully", "success");
                        window.location.reload();
                    }
                })
        }
    }

    const closemodal1 = () => {
        setModalopen1(false);
    }
    
    /*................Employment Datatable...............*/

    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => itm.serial,
            sortable: false,
            width: "200px",
        },
        {
            name: "Employment Type Name",
            selector: (itm: any) => itm.employmentTypesName,
            sortable: true,
            width: "250px",
        },
        {
            name: "Created Date",
            sortable: true,
            cell: (itm: any) => {
                var crDate = moment(itm.createdDate).format("DD-MM-YYYY")
                return (
                    <>
                        <IonText>{crDate}</IonText>
                    </>
                )
            }
        },
        {
            name: "Created By",
            selector: (itm: any) => itm.createdBy,
            sortable: true,
        },
        {
            name: "No. of Resources",
            selector: (itm: any) => itm.noOfResources,
            sortable: true,
        },
        {
            name: "Action",
            sortable: false,
            width: "100px",
            cell: (itm: any) => (
                <>
                    <div style={{ textDecoration: 'underline', textDecorationColor: "coral", paddingLeft: "15px" }}>
                        <IonText style={{ color: "coral", cursor: 'pointer' }} onClick={() => openmodal(itm.id)} >View</IonText>
                    </div>
                </>
            )
        }
    ]
  
    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px"
            },
        },
        cells: {
            style: {
                fontSize: "16px"
            }
        }
    };

/*...............Search filter.............*/

    const datatable = data.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );
    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }
        
        };
    
    return (
        <div style={{ display: "flex" }}>
            <div style={{ display: "flex" }}>
                <div className="form-group form-focus row">
                    <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                        value={filterText} placeholder="Search" />
                    <label className="focus-label">Search</label>
                </div>
                <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
            </div>
        </div>
    )
    
    }, [filterText, resetPaginationToggle]);
    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                    <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />
                                        Employement Types</h3>
                                </div>
                                <div className="col-auto float-end ml-auto">
                                    <a onClick={() => openmodal1()} className="btn add-btn" data-bs-toggle="modal" data-bs-target="#add_leave"><i className="fa fa-plus" /> Create Employement Type</a>
                                </div>
                            </div>
                            {loading && (
                                <div
                                    style={{
                                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                    }}
                                >
                                    <div >
                                        <IonSpinner style={{
                                            width: "40px",
                                            height: "40px",
                                            color: "#ff8a53"
                                        }} name="lines" />
                                    </div>
                                </div>
                            )}
                            <div className="table-responsive" style={{ marginTop: "1%" }}>
                                <DataTable
                                    columns={columns}
                                    data={datatable}
                                    pagination
                                    paginationPerPage={10}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[10, 20, 30]}
                                    subHeader
                                    subHeaderComponent={subHeaderComponent}
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                      {/*..............View Modal.............*/}

                <Modal
                  dialogClassName="modal-dialog modal-lg" 
                    // id="logouts-modal"
                    show={modalopen}
                >
                    <div className="modal-header">
                        <h5 className="modal-title">View Employment Type</h5>
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal()}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="form-group">
                                <label style={{ fontWeight: "bold" }}>Employment Type Name <span className="text-danger">*</span></label>
                                <div>
                                    <IonInput value={ETypeName} onIonChange={(e: any) => setETypeName(e.detail.value)} className="form-control datetimepicker" />
                                </div>
                            </div>
                            <div className="form-group">
                                <label style={{ fontWeight: "bold" }}>Employment Type Description <span className="text-danger">*</span></label>
                                <div>
                                    <IonInput value={ETypeDescription} onIonChange={(e: any) => setETypeDescription(e.detail.value)} className="form-control datetimepicker" />
                                </div>
                            </div>
                            <div className="submit-section">
                                <button type="button" className="btn-primary submit-btn" onClick={() => Update()}>Update</button>
                            </div>
                            <div className="form-group" style={{ marginTop: "2%" }}>
                                <label style={{ fontWeight: "bold" }}>Assigned Resources </label>
                                <div className="form-control datetimepicker" style={{ height: "150px", overflowY: "scroll", backgroundColor: "#DCDCDC" }}>
                                    {Resources.map((itm: any) => (
                                        <li>{itm}</li>
                                    ))}
                                </div>
                            </div>
                        </form>
                    </div>
                </Modal>

                 {/*......................Create Modal......................*/}

                <Modal
                  dialogClassName="modal-dialog modal-lg" 
                    // id="logouts-modal"
                    show={modalopen1}
                >
                    <div className="modal-header">
                        <h5 className="modal-title">
                            
                            Create Employement Type</h5>
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal1()}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="form-group">
                                <label style={{ fontWeight: "bold" }}>Employment Type Name <span className="text-danger">*</span></label>
                                <div>
                                    <IonInput value={eTName} onIonChange={(e: any) => setETName(e.detail.value)} className="form-control datetimepicker" />
                                </div>
                            </div>
                            <div className="form-group">
                                <label style={{ fontWeight: "bold" }}>Employment Type Description <span className="text-danger">*</span></label>
                                <div>
                                    <IonInput value={eTDescription} onIonChange={(e: any) => setETDescription(e.detail.value)} className="form-control datetimepicker" />
                                </div>
                            </div>
                            <div className="submit-section">
                                <button type="button" className="btn-primary submit-btn" onClick={() => Create()}>Create</button>
                            </div>
                        </form>
                    </div>
                </Modal>
            </IonContent>
        </IonPage>
    )
}

export default HREmployementtype